function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { resolveObj } from '@tecsinapse/es-utils/build';
import { Input, Select, LocaleContext } from '@tecsinapse/ui-kit';
import { EXACT_MATCH_CONST, INCLUDE_MATCH_CONST, isRemoteData } from '../../utils/tableFunctions';

var onChange = function onChange(onChangeFilter, setHeaderFilters) {
  return function (_ref) {
    var target = _ref.target;
    var name = target.name;
    var filterValue = target.value,
        _target$matchType = target.matchType,
        matchType = _target$matchType === void 0 ? INCLUDE_MATCH_CONST : _target$matchType;
    setHeaderFilters(function (prevHeaderFilters) {
      var newHeaderFilter = {};
      newHeaderFilter[name] = {
        value: filterValue,
        matchType: matchType
      };

      var mergedHeaderFilters = _objectSpread(_objectSpread({}, prevHeaderFilters), newHeaderFilter);

      onChangeFilter(mergedHeaderFilters);
      return mergedHeaderFilters;
    });
  };
};

var initialHeaderFilters = function initialHeaderFilters(columns) {
  var headerFilters = {};
  columns.filter(function (c) {
    return !c.selection && !c.actions;
  }).forEach(function (c) {
    headerFilters[c.field] = {
      value: '',
      matchType: c.select ? EXACT_MATCH_CONST : INCLUDE_MATCH_CONST
    };
  });
  return headerFilters;
};

var RowFilters = function RowFilters(_ref2) {
  var columns = _ref2.columns,
      rendered = _ref2.rendered,
      onChangeFilter = _ref2.onChangeFilter,
      data = _ref2.data,
      hideSelectFilterLabel = _ref2.hideSelectFilterLabel;

  var _useState = useState(initialHeaderFilters(columns)),
      _useState2 = _slicedToArray(_useState, 2),
      headerFilters = _useState2[0],
      setHeaderFilters = _useState2[1];

  var _useContext = useContext(LocaleContext),
      selectPromptMessage = _useContext.selectPromptMessage,
      selectAllMessage = _useContext.selectAllMessage;

  if (!rendered) {
    return null;
  }

  var rowFilterStyle = {
    backgroundColor: '#f5f5f5'
  };
  return /*#__PURE__*/React.createElement(TableRow, {
    style: rowFilterStyle
  }, columns.map(function (column) {
    var _ref3 = column || {},
        title = _ref3.title,
        field = _ref3.field,
        _ref3$options = _ref3.options,
        options = _ref3$options === void 0 ? {} : _ref3$options;

    var _options$visible = options.visible,
        visible = _options$visible === void 0 ? true : _options$visible,
        _options$select = options.select,
        select = _options$select === void 0 ? false : _options$select,
        _options$filter = options.filter,
        filter = _options$filter === void 0 ? false : _options$filter,
        selectOptionsProps = options.selectOptions;

    if (!visible) {
      return null;
    }

    var selectOptions;

    if (select && !selectOptionsProps && !isRemoteData(data)) {
      selectOptions = _toConsumableArray(new Set(data.map(function (o) {
        return resolveObj(field, o);
      }))).map(function (value) {
        return {
          value: value,
          label: value
        };
      });
    } else {
      selectOptions = _toConsumableArray(selectOptionsProps || []);
    }

    selectOptions = [{
      value: '',
      label: "".concat(selectPromptMessage, "...")
    }].concat(_toConsumableArray(selectOptions));

    var _ref4 = headerFilters[field] || {},
        filterValue = _ref4.value;

    var handleChange = function handleChange(value) {
      onChange(onChangeFilter, setHeaderFilters)({
        target: {
          name: field,
          value: value,
          matchType: EXACT_MATCH_CONST
        }
      });
    };

    var regularInputStyle = {
      backgroundColor: '#fff'
    };
    var customSelectStyle = {
      style: {
        backgroundColor: '#fff'
      }
    };
    var cellPadding = {
      paddingTop: '8px',
      paddingBottom: '8px'
    };
    return /*#__PURE__*/React.createElement(TableCell, {
      key: field,
      align: options.numeric ? 'right' : 'left',
      style: cellPadding
    }, filter && select && /*#__PURE__*/React.createElement(Select, {
      selectPromptMessage: selectPromptMessage,
      customTextField: customSelectStyle,
      selectAllMessage: selectAllMessage,
      value: filterValue,
      fullWidth: true,
      options: selectOptions || [],
      menuPlacement: "auto",
      onChange: handleChange,
      label: !hideSelectFilterLabel && title
    }), filter && !select && /*#__PURE__*/React.createElement(Input, {
      name: field,
      id: field,
      value: filterValue,
      startAdornment: /*#__PURE__*/React.createElement(Icon, {
        path: mdiMagnify,
        size: 1,
        color: "#C4C4C4"
      }),
      style: regularInputStyle,
      fullWidth: true,
      onChange: onChange(onChangeFilter, setHeaderFilters)
    }));
  }));
};

RowFilters.defaultProps = {
  rendered: false,
  hideSelectFilterLabel: false
};
RowFilters.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    field: PropTypes.string,
    options: PropTypes.shape({
      filter: PropTypes.bool
    })
  })).isRequired,
  rendered: PropTypes.bool,
  onChangeFilter: PropTypes.func.isRequired,
  hideSelectFilterLabel: PropTypes.bool
};
export default RowFilters;